import { render, staticRenderFns } from "./PendingWithdrawals.vue?vue&type=template&id=251f9c17&scoped=true"
import script from "./PendingWithdrawals.vue?vue&type=script&lang=js"
export * from "./PendingWithdrawals.vue?vue&type=script&lang=js"
import style0 from "./PendingWithdrawals.vue?vue&type=style&index=0&id=251f9c17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251f9c17",
  null
  
)

export default component.exports